// src/directives/tooltip.js
import { createPopper } from '@popperjs/core';

export default {
    mounted(el, binding) {
        let tooltip = document.createElement('div');
        tooltip.classList.add('tooltip');
        tooltip.style.position = 'absolute';
        tooltip.style.zIndex = '10000';
        tooltip.style.backgroundColor = 'white';
        tooltip.style.padding = '8px';
        tooltip.style.border = '1px solid #ccc';
        tooltip.style.borderRadius = '4px';
        tooltip.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
        tooltip.style.display = 'none';
        tooltip.textContent = binding.value || 'No content';
        document.body.appendChild(tooltip);

        let popperInstance;

        el.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
            popperInstance = createPopper(el, tooltip, {
                placement: 'top', // 可以根据需要调整位置
            });
        });

        el.addEventListener('mousemove', (e) => {
            console.log(e);
            if (popperInstance) {
                popperInstance.update();
            }
        });

        el.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
            if (popperInstance) {
                popperInstance.destroy();
                popperInstance = null;
            }
        });
    },
    unmounted(el) {
        console.log('el', el);
        const tooltip = document.querySelector('.tooltip');
        if (tooltip) {
            tooltip.remove();
        }
    }
};